import { NumericFormat } from 'react-number-format';

const formatPercent = (value: number | string) => {
  return (
    <NumericFormat
      value={value.toString()}
      displayType="text"
      thousandSeparator={' '}
      decimalScale={2}
      suffix="%"
      renderText={(formattedValue) => formattedValue}
    />
  );
};

export default formatPercent;
